import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from '../../constants';


const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const FETCH_INVOICES = createApiNamespacedConstants('FETCH_INVOICES');
